import { useEffect } from "react";

// Calls `loadFn(signal)` whenever loadFn changes. The signal aborts on unmount
// or when loadFn changes, so stale responses cannot overwrite fresh state.
// `loadFn` should be wrapped in useCallback so its identity is stable across renders.
// Inside loadFn, pass the signal to each fetch and silence AbortError via isAbortError.
export function useAbortableLoader(loadFn) {
  useEffect(() => {
    const ac = new AbortController();
    loadFn(ac.signal);
    return () => ac.abort();
  }, [loadFn]);
}

export function isAbortError(err) {
  return err?.name === "AbortError";
}
